import Vue from 'vue'
import Router from 'vue-router'
import axios from 'axios' //axios

Vue.use(Router)

function loadView(view) {
  return () => import(/* webpackChunkName: "view-[request]" */ '../page/'+view+'.vue')
}

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: loadView('home')
    },
    {
      path: '/my',
      name: 'my',
      component: loadView('my')
    },
    {
      path: '/book',
      name: 'book',
      component: loadView('book')
    },
    {
      path: '/answer',
      name: 'answer',
      component: loadView('answer_new')
    },
    {
      path: '/sousuo',
      name: 'sousuo',
      component: loadView('sousuo')
    },
    {
      path: '/buy',
      name: 'buy',
      component: loadView('buy')
    },
    {
      path: '/test',
      name: 'test',
      component: loadView('test')
    },
    {
      path: '/bookabout',
      name: 'bookabout',
      component: loadView('bookabout')
    },
    {
      path: '/allbook',
      name: 'allbook',
      component: loadView('allbook')
    }
  ]
})

// 获取链接字段
function getUrlParam (url, name) {
  var reg = new RegExp('(\\?|&)' + name + '=([^&]+)');
  var r = url.substr(1).match(reg);
  if (r != null) return decodeURIComponent(r[2]);
  return '';
};

router.beforeEach((to, from, next) => {
  var urlid = getUrlParam(window.location.href,'id')
  var type = getUrlParam(window.location.href,'type')
  type = type ? type.replace('#/',''): type
  if (type === 'book' && urlid && to.path !== '/book') {
    next('/book' + '?bookid=' + urlid)
  } else if (type === 'chapter' && urlid && to.path !== '/bookabout') {
    next('/bookabout' + '?chapterId=' + urlid)
  } else {
    next();
  }
 });

 export default router;



// WEBPACK FOOTER //
// ./src/router/index.js